Monet.PolylineEncoder = function PolylineEncoder () {

    var THRESHOLD = 0x20;
    var ELE_PRECISION = 1e2;
    var PRECISION = 1e6;

    var _decode = function (fromEncode, encoded, fromPoint, point) {
        var value;
        var shift = 0;
        var result = 0;
        var idx = fromEncode;
        do {
            value = encoded[idx++].charCodeAt(0) - 63;
            result |= (value & 0x1f) << shift;
            shift += 5;
        } while (value >= THRESHOLD);

        value = result >> 1;

        if ((result & 1) !== 0) {
            value = ~value;
        }
        point[fromPoint] = point[fromPoint] + value;
        return idx;
    };

    function Point (latitude, longitude, elevation) {
        this.lat = latitude;
        this.lon = longitude;
        this.ele = elevation;
    };

    var createPoint = function (point, is3D) {
        var latitude = increasePrecision(point[0], PRECISION);
        var longitude = increasePrecision(point[1], PRECISION);
        var elevation = null;

        if (is3D) {
            elevation = increasePrecision(point[2], ELE_PRECISION);
        }
        return new Point(latitude, longitude, elevation);
    };

    function increasePrecision (value, precision) {
        return value / precision;
    }

    this.decode = function (encodedPoints, is3D) {
        var size = is3D ? 3 : 2;
        var idxPoint = 0;
        var idxEncode = 0;
        var point = [];

        for (var i = 0; i < size; i++) {
            point[i] = 0;
        }

        var encoded = encodedPoints.split('');
        var points = [];

        while (idxEncode < encoded.length) {
            idxEncode = _decode(idxEncode, encoded, idxPoint, point);
            idxPoint++;

            if (idxPoint === size) {
                points.push(createPoint(point, is3D));
                idxPoint = 0;
            }
        }
        return points;
    };

};